import { render, staticRenderFns } from "./PdfPreviewPage.vue?vue&type=template&id=727ac5c0&scoped=true"
import script from "./PdfPreviewPage.vue?vue&type=script&lang=js"
export * from "./PdfPreviewPage.vue?vue&type=script&lang=js"
import style0 from "./PdfPreviewPage.vue?vue&type=style&index=0&id=727ac5c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727ac5c0",
  null
  
)

export default component.exports